import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { AppIcon } from '../icons/app_icon';
import { Card } from '../card/card';
import { CloseButton } from '../buttons/index';
import styled from '../../styles/styled';
import Theme from '../../styles/theme';
export var ToastTypes;
(function (ToastTypes) {
    ToastTypes["SUCCESS"] = "success";
    ToastTypes["INFO"] = "info";
    ToastTypes["ERROR"] = "error";
    ToastTypes["WARNING"] = "warning";
    ToastTypes["CAUTION"] = "caution";
})(ToastTypes || (ToastTypes = {}));
export const Toast = ({ flavor, id, onClose, onPauseToastTimeout, onResumeToastTimeout, children }) => {
    useEffect(() => {
        document.addEventListener('keydown', handleTabbing, true);
        return () => {
            document.removeEventListener('keydown', handleTabbing, true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleTabbing = (e) => {
        if (e.key === 'Tab')
            document.getElementById(id).focus();
        document.removeEventListener('keydown', handleTabbing, true);
    };
    let flavorColorValue;
    let iconName;
    switch (flavor) {
        case ToastTypes.SUCCESS:
            flavorColorValue = Theme.colors.greenShamrock;
            iconName = 'DoneIcon';
            break;
        case ToastTypes.ERROR:
            flavorColorValue = Theme.colors.red50;
            iconName = 'AlertIcon';
            break;
        case ToastTypes.WARNING:
            flavorColorValue = Theme.colors.pumpkin;
            iconName = 'AlertIcon';
            break;
        case ToastTypes.CAUTION:
            flavorColorValue = Theme.colors.yellow;
            iconName = 'AlertIcon';
            break;
        default:
        case ToastTypes.INFO:
            flavorColorValue = Theme.colors.azure;
            iconName = 'InformationIcon';
            break;
    }
    return (_jsxs(ToastCard, { onMouseEnter: onPauseToastTimeout, onFocus: onPauseToastTimeout, onMouseLeave: onResumeToastTimeout, onBlur: onResumeToastTimeout, role: "alert", "aria-live": "polite", id: id, tabIndex: 0, flavorColorValue: flavorColorValue, children: [_jsx(DecoratorIcon, { color: flavorColorValue, name: iconName }), _jsx(ContentWrapper, { children: children }), _jsx(Close, { label: 'Close toast', onClick: onClose })] }));
};
const ToastCard = styled(Card)(({ flavorColorValue }) => {
    return {
        display: 'grid',
        width: 'calc(100vw - 80px)',
        maxWidth: '400px',
        gridTemplateColumns: 'auto 1fr auto',
        borderLeft: `solid 8px ${flavorColorValue}`,
        padding: '0',
        alignItems: 'center',
    };
});
const DecoratorIcon = styled(AppIcon)({
    margin: '16px',
    height: '24px',
});
const ContentWrapper = styled.div({
    margin: '12px 0',
    wordBreak: 'break-word',
});
const Close = styled(CloseButton)({
    margin: '16px',
    alignSelf: 'start',
});
//# sourceMappingURL=toast.js.map